export const surveyQuestions = [
  {
    id: 1,
    key: "Travel Type",
    questionText: "Where would you like to travel?",
    options: ["International", "Domestic"],
    type: "radio",
    others: "",
    response: [],
  },
  {
    id: 2,
    key: "Travel Destination",
    questionText: "Where would you like to Travel?",
    options: [
      "Baku",
      "Vietnam",
      "Sikkim Darjeeling",
      "Rajasthan",
      "Other (please specify)",
    ],
    type: "radio",
    others: "",
    response: [],
  },
  {
    id: 3,
    key: "Travel Budget",
    questionText: "What is your budget for the trip?",
    options: [
      "Below ₹50,000",
      "₹50,000 - ₹1,00,000",
      "₹1,00,000 - ₹1,50,000",
      "Above ₹1,50,000",
    ],
    type: "radio",
    others: "",
    response: [],
  },
  {
    id: 4,
    key: "Preferred Time",
    questionText: "What is your preferred time of the year?",
    options: ["Jan - Mar", "Apr - Jun", "Jul - Sep", "Oct - Dec"],
    type: "radio",
    others: "",
    response: [],
  },
  {
    id: 5,
    key: "Group Tour",
    questionText: "Are you interested in a group tour?",
    options: ["Yes", "No"],
    type: "radio",
    others: "",
    response: [],
  },

  {
    id: 6,
    key: "Group Type",
    questionText:
      "Which type of tour(s) are you interested in? (Select all that apply)",
    options: [
      "Women's Tours",
      "Cultural Tours",
      "Luxury Tours",
      "Budget Tours",
      "Family Tours",
      "Solo Traveler Tours",
      "Other (please specify)",
    ],
    type: "checkbox",
    others: "",
    response: [],
  },
  {
    id: 7,
    key: "Specific Requirements",
    questionText:
      "Do you have any specific preferences or requirements for your trip?",
    options: [],
    type: "textbox",
    others: "",
    response: [],
  },
];
